import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { styled, css } from "@mui/system";
import { Modal as BaseModal } from "@mui/base/Modal";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { LoaderSpinner } from "../../components/spinner/loader";

export const PicturesModal = ({ open, setOpen, images = [] }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const handleClose = () => {
    setCurrentIndex(0);
    setOpen(false);
  };
  const [imageDimensions, setImageDimensions] = useState({
    width: 0,
    height: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadImageDimensions = (imageUrl) => {
      const image = new Image();
      image.src = imageUrl;

      image.onload = () => {
        const { width, height } = image;
        const aspectRatio = width / height;

        // Calculate dimensions respecting maxWidth and maxHeight
        const calculatedWidth = Math.min(width, 300);
        const calculatedHeight = Math.min(calculatedWidth / aspectRatio, 300);

        setImageDimensions({
          width: calculatedWidth,
          height: calculatedHeight,
        });
      };
    };

    loadImageDimensions(images[currentIndex]);
  }, [images, currentIndex]);

  const handleNextImage = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images?.length);
  };

  const handlePrevImage = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + images?.length) % images?.length
    );
  };

  const handleImageLoad = () => {
    setLoading(false);
  };

  const Backdrop = React.forwardRef((props, ref) => {
    const { open, ...other } = props;
    return <div ref={ref} {...other} />;
  });

  const Modal = styled(BaseModal)`
    position: fixed;
    z-index: 1300;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  `;

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: '80vw',
    maxWidth: 1000,
    height: '90vh',
    maxHeight: '90vh',
    background: 'white',
    borderRadius: 8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  };

  const StyledBackdrop = styled(Backdrop)`
    z-index: -1;
    position: fixed;
    inset: 0;
    background-color: rgb(0 0 0 / 0.5);
    -webkit-tap-highlight-color: transparent;
  `;

  const ModalContent = styled("div")(
    ({ theme }) => css`
      height: 80%;
      position: relative;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      flex-direction: row;
      gap: 8px;
      overflow: hidden;
      background-color: #f1ecec;
      border-radius: 8px;
      box-shadow: 0 4px 12px rgb(0 0 0 / 0.5);
      padding: 24px;
      color: black;

      & .image {
        max-width: "100%";
        max-height: "100%";
        width: ${imageDimensions.width}px;
        height: ${imageDimensions.height}px;
      }

      & .icon-container {
        position: absolute;
        top: 5px;
        right: 10px;
      }

      & .close-icon {
        width: 40px;
        height: 40px;
      }
    `
  );

  return (
    <div>
      <Modal
        aria-labelledby="spring-modal-title"
        aria-describedby="spring-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: StyledBackdrop }}
      >
        <ModalContent sx={style}>
          <div className="icon-container">
            <CloseIcon className="close-icon" onClick={handleClose} />
          </div>
          {images?.length > 1 && (
            <div className="arrow-container" onClick={handlePrevImage}>
              <ArrowBackIosNewIcon />
            </div>
          )}
          {!images[currentIndex] ? (
            <h4>No existen imagenes para esta orden</h4>
          ) : (
            <>
              <img
                className="image"
                src={images[currentIndex]}
                alt={`Image ${currentIndex + 1}`}
                onLoad={handleImageLoad}
                style={{
                  maxWidth: '100%',
                  maxHeight: '80vh',
                  width: 'auto',
                  height: 'auto',
                  display: 'block',
                  margin: '0 auto',
                  borderRadius: 12,
                  boxShadow: '0 4px 12px rgb(0 0 0 / 0.5)',
                }}
              />
              {loading && (
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <LoaderSpinner />
                </div>
              )}
            </>
          )}
          {images?.length > 1 && (
            <div className="arrow-container" onClick={handleNextImage}>
              <ArrowForwardIosIcon />
            </div>
          )}
        </ModalContent>
      </Modal>
    </div>
  );
};
